import getTableViewFromTableQuery from './getTableViewFromTableQuery';
import onInitialTableLoadComplete from './onInitialTableLoadComplete';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { lazyCleanSearchTableState, lazyLoadSearchTable } from 'owa-mail-execute-search-actions';
import onLoadInitialRowsSucceeded from 'owa-mail-list-actions/lib/actions/table/onLoadInitialRowsSucceeded';
import loadInitialMailTable from 'owa-mail-list-actions/lib/actions/table/loadInitialMailTable';
import loadInitialGroupTable from 'owa-mail-list-actions/lib/actions/table/loadInitialGroupTable';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { MailListItemSelectionSource } from 'owa-mail-store';
import getPersonaPhotoQueue from 'owa-persona/lib/actions/getPersonaPhotoQueue';
import { action, select } from 'satcheljs/lib/legacy';
import { resetSelection } from 'owa-mail-actions';
import { listViewStore, } from 'owa-mail-list-store';
/**
 * Called before loading a new table
 * @param oldTableView the old table view
 */
function onBeforeTableLoad(oldTableView) {
    // always clear the getPersonaPhotoQueue when switching the table
    getPersonaPhotoQueue.clear();
    // Always reset the selection on the old table.
    resetSelection(oldTableView, MailListItemSelectionSource.Reset);
}
/**
 * Called after loading the new table
 * @param oldTableView the old table view
 */
function onAfterTableLoad(oldTableView, newTableView) {
    // Clean the old table View's state.
    // Currently we do not have to clean up anything on a non-search (or Folder) table
    // as we are caching them and the only clean up that we peform is the resetting the selection
    if (oldTableView.tableQuery.type === 1 /* Search */ &&
        oldTableView.id !== newTableView.id) {
        var actionDatapoint = returnTopExecutingActionDatapoint();
        lazyCleanSearchTableState(oldTableView, actionDatapoint);
    }
}
var loadTableViewFromTableQueryActionName = 'loadTableViewFromTableQuery';
export { loadTableViewFromTableQueryActionName };
/**
 * Load the table from the table query
 * @param tableQuery the table query
 * @param loadTableViewDatapoint - performance datapoint that starts when the user initiates the table load
 * @param actionSource action that initiated the switch folder action
 * @param state the state which contains the list view store
 * @return a promise that resolves when the load table from server has completed
 */
export default action(loadTableViewFromTableQueryActionName)(select({
    listViewStore: function () { return listViewStore; },
})(function loadTableViewFromTableQuery(tableQuery, loadTableViewDatapoint, actionSource, state) {
    var oldTableView = getSelectedTableView();
    var newTableView = getTableViewFromTableQuery(tableQuery);
    // Use the reference from the store (http://aka.ms/mobx4)
    tableQuery = newTableView.tableQuery;
    // 1. Set the current selected table in list view store to the new table
    state.listViewStore.selectedTableViewId = newTableView.id;
    // 2. Call onBeforeTableLoad before loading new table
    if (oldTableView) {
        // oldTableView is null when first loading OWA as there is no previously selected table
        onBeforeTableLoad(oldTableView);
    }
    // 3. Load New Table
    var loadTablePromise;
    switch (tableQuery.type) {
        case 1 /* Search */:
            loadTablePromise = lazyLoadSearchTable.importAndExecute(newTableView, onInitialTableLoadComplete, onLoadInitialRowsSucceeded, actionSource, loadTableViewDatapoint);
            break;
        case 2 /* Group */:
            loadTablePromise = loadInitialGroupTable(newTableView, onInitialTableLoadComplete, actionSource);
            break;
        case 0 /* Folder */:
            loadTablePromise = loadInitialMailTable(newTableView, onInitialTableLoadComplete, actionSource);
            break;
        default:
            throw new Error('Only Folder, Group or Search Table types are supported in Table Loading');
    }
    // 4. Call onAfterTableLoad after loading new table
    if (oldTableView) {
        onAfterTableLoad(oldTableView, newTableView);
    }
    return loadTablePromise;
}));
//# sourceMappingURL=loadTableViewFromTableQuery.js.map